"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNftRewardPrizeBodyToJSON = exports.UpdateNftRewardPrizeBodyFromJSONTyped = exports.UpdateNftRewardPrizeBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function UpdateNftRewardPrizeBodyFromJSON(json) {
    return UpdateNftRewardPrizeBodyFromJSONTyped(json, false);
}
exports.UpdateNftRewardPrizeBodyFromJSON = UpdateNftRewardPrizeBodyFromJSON;
function UpdateNftRewardPrizeBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'prizeRevealName': json['prizeRevealName'],
        'quantity': json['quantity'],
        'sortOrder': json['sortOrder'],
        'onlyAvailableAfterWins': !(0, runtime_1.exists)(json, 'onlyAvailableAfterWins') ? undefined : json['onlyAvailableAfterWins'],
        'rewardConfigId': !(0, runtime_1.exists)(json, 'rewardConfigId') ? undefined : json['rewardConfigId'],
    };
}
exports.UpdateNftRewardPrizeBodyFromJSONTyped = UpdateNftRewardPrizeBodyFromJSONTyped;
function UpdateNftRewardPrizeBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'prizeRevealName': value.prizeRevealName,
        'quantity': value.quantity,
        'sortOrder': value.sortOrder,
        'onlyAvailableAfterWins': value.onlyAvailableAfterWins,
        'rewardConfigId': value.rewardConfigId,
    };
}
exports.UpdateNftRewardPrizeBodyToJSON = UpdateNftRewardPrizeBodyToJSON;
